module.exports = __webpack_public_path__ + "images/internal/datashake/insider_pages.png";